var MuiTooltip = {
    /* put your new default props here */
    placement: 'right-start',
};
export default MuiTooltip;
//# sourceMappingURL=MuiTooltip.js.map